import { styled, Box } from '@mui/material'
import { iconGridStyle } from '../layout'

export const IconCard = styled(Box)(iconGridStyle)
